// Mock promotion data for validation (replace with API call if available)
const mockPromotions = [
  {
    name: "Basic Deal",
    applicableRatePlans: ["Full Board"],
  },
  {
    name: "Last Minute",
    applicableRatePlans: ["Full Board"],
  },
  {
    name: "Early Bird",
    applicableRatePlans: ["Full Board"],
  },
];

export { mockPromotions };
